/* pdp-gallery.js — shared PDP media + perf engine (phase 2a, built dark; loaded by nothing yet).
   Extracted verbatim from the jade/rose/sanctum family, which was byte-identical here modulo
   product identifiers. Everything in this file reads the shared markup contract from the DOM
   (`.pdp` scope, `#gmain`, `.gthumb`, `.gcar-track`, `.gcar-dots`, `.pdp video source[data-src]`)
   and holds no product identity — the buy-box wiring lives in pdp-atc.js.

   Best-of decisions folded in (deviations from plain jade, each deliberate):
     - Entry guard `if(!main)return;` taken from product-bundle-pdp.js (cleaner than jade's
       per-call `if(main)` guards; behaviour-identical when #gmain is present).
     - Deferred-slides selector standardised to `data-premium-gallery-deferred="slides"` — the
       value the contract suite already pins for rose/sanctum — and jade's dead "thumb-images"
       branch (+ `[data-deferred-thumb]` slots) dropped; grep found zero live callers.
     - Below-fold video: merged best-of. jade/rose connection-awareness (Data Saver / 2G gate)
       AND inner-sanctum's withheld-poster fix (data-poster) AND its reduced-motion poster pass,
       in one `arm()` that always reveals the poster and only withholds the video payload.
     - inner-sanctum null-guard style (`if(el)…`) on every observer target that isn't guaranteed.

   CONTRACT STRINGS: the cross-fade block reproduces the exact substrings pinned by
   tests/test_storefront_performance_contracts.py (gset/gcommit/gmain-x). Do not reword them. */
(function(){

/* ---- hero gallery: cross-fade swap + swipe carousel ---- */
(function(){
  var main=document.getElementById('gmain');
  if(!main)return;
  /* A second layer stacked on the first, so one photograph can dissolve into
     the next instead of being replaced mid-air. */
  var gReduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  var gx=null;
  if(!gReduce&&main.parentNode){
    gx=document.createElement('img');
    gx.className='gmain-x';gx.setAttribute('alt','');gx.setAttribute('aria-hidden','true');
    gx.decoding='async';main.parentNode.appendChild(gx);
  }
  function gGuard(img){if(!img||img.__g)return;img.__g=1;function retry(){var r=+(img.getAttribute('data-gr')||0);if(r>=2){img.style.opacity='';return;}img.setAttribute('data-gr',r+1);img.style.opacity='0';var s=img.src;img.removeAttribute('src');setTimeout(function(){img.src=s;},260*(r+1));}img.addEventListener('error',retry);img.addEventListener('load',function(){img.style.opacity='';img.removeAttribute('data-gr');});if(img.complete&&img.naturalWidth===0)retry();}
  gGuard(main);
  [].slice.call(document.querySelectorAll('.gcar-track img')).forEach(gGuard);
  var thumbs=[],gidx=0;
  /* The desktop gallery used to wrap: at the last image, Next jumped back to
     the first with no signal, which reads as the gallery resetting itself
     (Sho hit exactly this). A finite gallery ends: clamp, fade, aria-disable. */
  function gedgeSync(){var g=document.querySelector('.gallery');if(!g)return;
    var last=thumbs.length-1;
    var e=gidx<=0?'start':(gidx>=last?'end':'');
    if(e)g.setAttribute('data-edge',e);else g.removeAttribute('data-edge');
    if(gp)gp.setAttribute('aria-disabled',gidx<=0?'true':'false');
    if(gn)gn.setAttribute('aria-disabled',gidx>=last?'true':'false');}
  /* Tide stop, desktop: pressing past the end pulls the photograph 10px and
     releases. Same physical language as the mobile strip. Reduced motion
     gets the fade alone. */
  var gnAt=0;
  function gnudge(dir){var now=Date.now();if(now-gnAt<260)return;gnAt=now;
    if(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    if(!main)return;
    var cls=dir>0?'gm-nudge-r':'gm-nudge-l';
    main.classList.add(cls);
    setTimeout(function(){main.classList.remove(cls);},130);}
  /* THE POSITION RAIL. The tool gallery's, driven the way the tool script drives
     it: a padded index and a filled segment that steps one frame at a time. It
     replaces the dots this gallery drew on a phone, which were the last of the
     five ways this store showed gallery position. */
  var railEl=document.querySelector('[data-pdp-counter]');
  var railCur=railEl&&railEl.querySelector('[data-rail-current]');
  var railFill=railEl&&railEl.querySelector('[data-rail-fill]');
  var railLive=railEl&&railEl.querySelector('[data-rail-live]');
  var railTotal=railEl?(+railEl.getAttribute('data-gallery-count')||0):0;
  var railTimer=null;
  function railSet(i){
    if(!railEl||railTotal<2)return;
    var n=Math.max(1,Math.min(railTotal,i+1));
    if(railCur)railCur.textContent=n<10?'0'+n:String(n);
    if(railFill)railFill.style.transform='translateX('+((n-1)*100)+'%)';
    if(railLive){clearTimeout(railTimer);railTimer=setTimeout(function(){
      var t=railEl.getAttribute('data-gallery-announce')||'Image {index} of {total}';
      railLive.textContent=t.replace('{index}',String(n)).replace('{total}',String(railTotal));},350);}
  }

  function gshow(i){if(!thumbs.length)return;gidx=Math.max(0,Math.min(thumbs.length-1,i));gedgeSync();railSet(gidx);
    thumbs.forEach(function(x){x.classList.remove('active');x.removeAttribute('aria-current');});
    thumbs[gidx].classList.add('active');
    thumbs[gidx].setAttribute('aria-current','true');
    var url=thumbs[gidx].getAttribute('data-full');
    if(main.dataset.ssVt===undefined)main.dataset.ssVt=main.style.viewTransitionName;
    main.style.viewTransitionName=gidx===0?main.dataset.ssVt:'none';
    /* A srcset outranks src, so leaving one on a JS-swapped image means the
       picture silently never changes. Clear it on every swap -- AFTER src is
       set (2026-11-01): WebKit starts a fetch on each write, and removing
       srcset first sent it back to #gmain's src attribute, the 1080 lead
       frame, on the first swap of every visit. With src written first, the
       srcset still wins that write (the frame on screen, in cache) and the
       removal lands on url, which the warm Image already holds. */
    function gset(el,u){el.src=u;el.removeAttribute('srcset');el.removeAttribute('sizes');}
    /* Never cut to a frame that has not arrived. Decode first, then cross the
       two layers, so the picture changes the way a page turns rather than
       blinking through white. */
    /* THE ALT TRAVELS WITH THE PICTURE (2026-09-12). This engine swapped the
       src and left #gmain's alt on slide 1 forever, so a screen reader was told
       "the bottle in its velvet box" on every frame of an eight-slide gallery.
       The markup already carries the per-slide string on the thumb
       (data-full-alt, from thumb_labels in snippets/pdp-gallery), and the
       engine Myrrh Oil just came off did exactly this. Written OUTSIDE gset:
       that function's bytes are pinned by
       tests/test_storefront_performance_contracts.py and must not be reworded. */
    function galt(){var a=thumbs[gidx].getAttribute('data-full-alt');if(a!==null)main.alt=a;}
    /* THE RUNG, THE PLACEHOLDER AND THE ORDER (2026-09-23).
       - The frame is fetched through gimg(): the thumb's data-full-srcset with
         the main image's own sizes, so a phone takes the 780 rung (the one the
         lead frame already paints) instead of the 1080 data-full, which is
         about twice the bytes for a 358px box. url becomes the rung the browser
         picked, so the commit reuses those decoded bytes.
       - If the frame is not in hand, the tapped slide's thumbnail (already
         on screen) goes up on the dissolve layer at once.
       - Only the newest tap commits; gbusy holds every warm off the wire
         until the tapped frame has landed.
       Slow 4G + 4x CPU, Inner Sanctum, tap at load + 1 s: see the PR. */
    var mine=++gseq;gbusy=true;
    function gcommit(){
      if(mine!==gseq)return;
      gbusy=false;
      url=pre.currentSrc||url;
      galt();
      gwarmSoon();
      if(!gx||gReduce){gset(main,url);return;}
      gset(gx,url);
      gx.classList.add('on');
      var done=function(){gset(main,url);if(mine===gseq)gx.classList.remove('on');};
      var t=setTimeout(done,420);
      gx.addEventListener('transitionend',function h(e){if(e.propertyName!=='opacity')return;
        gx.removeEventListener('transitionend',h);clearTimeout(t);done();},{once:false});
    }
    var pre=gimg(gidx);
    if(gx&&!gReduce&&!(pre.complete&&pre.naturalWidth)){
      var ti=thumbs[gidx].querySelector('img');
      if(ti&&ti.complete&&ti.naturalWidth){gset(gx,ti.currentSrc||ti.src);gx.classList.add('on');}
    }
    /* Bytes first, then the decode. decode() alone is not a wait on an Image
       whose sizes/srcset/src were just set: each setter queues an image update,
       and a superseded update rejects the pending decode at once, which
       committed a frame that had not arrived (traced 2026-09-23). */
    var gready=function(){if(pre.decode)pre.decode().then(gcommit).catch(gcommit);else gcommit();};
    if(pre.complete&&pre.naturalWidth)gready();
    else{pre.addEventListener('load',gready,{once:true});pre.addEventListener('error',gcommit,{once:true});}
  }
  /* One Image per frame, kept, so a warmed frame is found decoded. */
  /* The rung ladder is for phones only (the 749px query the gallery's own
     sizes caps). On a desktop the photo box is ~670 CSS px while sizes still
     says 533px, so the ladder would hand a DPR-1 screen the 540 rung; there the
     frames keep data-full (the top rung), exactly as before. */
  var gcache={},gseq=0,gbusy=false,gsizes=main.getAttribute('sizes')||'';
  var gphone=!!(window.matchMedia&&window.matchMedia('(max-width: 749px)').matches);
  function gimg(i){var t=thumbs[i];if(!t)return null;var u=t.getAttribute('data-full');var c=gcache[u];if(c&&!(c.complete&&!c.naturalWidth))return c;
    var im=new Image();im.decoding='async';var ss=t.getAttribute('data-full-srcset');
    if(gphone&&ss&&gsizes){im.sizes=gsizes;im.srcset=ss;}im.src=u;gcache[u]=im;return im;}
  /* Warm the NEXT frame only, never while a tap is in flight (the warm must not
     share the pipe with the frame the reader asked for), never on Data Saver. */
  /* Kept two frames ahead (i+1 and i+2), started only while no tap is in
     flight: at load, on first touch, and each time a tapped frame lands. */
  function gwarm(){if(gbusy||(navigator.connection||{}).saveData)return;
    for(var k=gidx+1;k<=gidx+2&&k<thumbs.length;k++)gimg(k);}
  function gwarmSoon(){gwarm();}
  function bindThumbs(){
    thumbs=[].slice.call(document.querySelectorAll('.gthumb')).filter(function(t){return t.getAttribute('data-full')});
    thumbs.forEach(function(t,i){if(t.__gb)return;t.__gb=1;t.addEventListener('click',function(){gshow(i);});});
  }
  function hydrateExtendedGallery(){
    var slidesTemplate=document.querySelector('template[data-premium-gallery-deferred="slides"]');
    if(slidesTemplate)slidesTemplate.replaceWith(slidesTemplate.content.cloneNode(true));
    [].slice.call(document.querySelectorAll('.gcar-track img')).forEach(gGuard);
    bindThumbs();
    gwarm();
  }
  bindThumbs();
  /* After load: the thumbnail strip stops being lazy (each is a few KB and is the
     instant placeholder above), then the frames a first and second Next need.
     Not on Data Saver or 2g. Nothing here runs inside the LCP window. */
  /* Frame two also when #gmain itself has landed (2026-10-30). PostHog, 14
     days to 30 Oct: 12 of 20 gnext rage clicks came within 5 s of the
     pageview; window load waits for every lazy image and tag on these pages,
     so the first Next fetched frame two cold, behind the rest of the page.
     The hero's own load is when it stops needing the pipe. Once only (the
     listener is once; gshow() reassigns main.src later). */
  /* RESHAPED 2026-10-31: the hero's load now fetches frame two ALONE, through
     a <link rel=preload as=image>, and the strip and gwarm() wait for window
     load again. A new Image() (and, in Firefox, a lazy thumbnail flipped to
     eager) holds window `load` until it lands, and snippets/gtm-loader starts
     the tags at `load` for a visitor who has not touched the page; a preload
     holds `load` in none of Chromium, Firefox and WebKit, goes out with the
     image Accept header the CDN varies on, and gimg() is then served from it
     with no second request (tests/browser/gallery-warm-keeps-load-proof.mjs).
     Same srcset/sizes rule as gimg(), so the same rung; skipped where the
     browser cannot preload by srcset. */
  (function(){var c=navigator.connection||{};if(c.saveData||/(^|-)2g$/.test(c.effectiveType||''))return;
    var go=function(){[].slice.call(document.querySelectorAll('.gthumb img[loading="lazy"]')).forEach(function(im){im.loading='eager';});
      setTimeout(gwarm,0);};
    var early=function(){var t=thumbs[gidx+1];if(gbusy||!t||document.readyState==='complete')return;var u=t.getAttribute('data-full');if(gcache[u])return;
      var l=document.createElement('link'),ss=t.getAttribute('data-full-srcset'),bySet=gphone&&ss&&gsizes;
      if(!(l.relList&&l.relList.supports&&l.relList.supports('preload'))||(bySet&&!('imageSrcset' in l)))return;
      l.rel='preload';l.as='image';l.setAttribute('fetchpriority','low');
      if(bySet){l.setAttribute('imagesrcset',ss);l.setAttribute('imagesizes',gsizes);}
      l.href=u;document.head.appendChild(l);};
    if(document.readyState==='complete')go();
    else{addEventListener('load',go,{once:true});if(main.complete&&main.naturalWidth)early();else main.addEventListener('load',early,{once:true});}})();
  var gallery=document.querySelector('.gallery');
  if(gallery){
    gallery.addEventListener('pointerover',hydrateExtendedGallery,{once:true,passive:true});
    gallery.addEventListener('focusin',hydrateExtendedGallery,{once:true});
    gallery.addEventListener('touchstart',hydrateExtendedGallery,{once:true,passive:true});
  }
  var gp=document.querySelector('.gprev'),gn=document.querySelector('.gnext');
  if(gp)gp.addEventListener('click',function(){hydrateExtendedGallery();if(gidx<=0){gedgeSync();gnudge(-1);return;}gshow(gidx-1);});
  if(gn)gn.addEventListener('click',function(){hydrateExtendedGallery();if(gidx>=thumbs.length-1){gedgeSync();gnudge(1);return;}gshow(gidx+1);});
  gedgeSync();
  // mobile swipe gallery — dots sync + arrows
  var track=document.querySelector('.gcar-track'),dots=document.querySelectorAll('.gcar-dots i');
  if(track&&dots.length){
    /* Later slides live in a <template> and hydrate on first touch, so the slide
       list grows underneath us. Re-read it whenever the count changes rather than
       trusting a snapshot taken before the gallery was even opened. */
    var slides=[];
    function S(){var n=track.querySelectorAll('img');if(n.length!==slides.length)slides=[].slice.call(n);return slides;}
    /* Every slide is one viewport wide PLUS the flex gap, so scrolling by
       clientWidth always stops short of the next one. Measure the real distance. */
    function cwidth(){var s=S();var w=s.length>1?(s[1].offsetLeft-s[0].offsetLeft):0;
      /* The carousel is display:none on desktop, where every measurement is 0.
         Never divide by that, or the index becomes NaN and no dot lights up. */
      return w>0?w:(track.clientWidth||1);}
    function cpos(i){var s=S();return s[i]?(s[i].offsetLeft-s[0].offsetLeft):i*cwidth();}
    function cnear(){var i=Math.round(track.scrollLeft/cwidth());if(!isFinite(i))i=0;return Math.max(0,Math.min(S().length-1,i));}
    /* Warm the neighbours before the finger arrives. */
    function cwarm(i){var s=S();[i,i+1,i+2].forEach(function(k){cwarmOne(s[k]);});}
    function cwarmOne(im){if(!im||im.__warm)return null;
      if(im.dataset&&im.dataset.src&&!im.getAttribute('src'))im.setAttribute('src',im.dataset.src);
      var u=im.currentSrc||im.getAttribute('src');if(!u)return null;
      im.__warm=1;
      /* Changing loading from lazy to eager does not reliably start a fetch,
         so pull the bytes with a throwaway Image and let the real element
         take them from cache. */
      /* sizes before srcset (2026-10-31): WebKit picks a candidate as soon as
         srcset is set, with the 100vw default, so a phone fetched each slide at
         1080w and then again at the 780w the slide itself asks for. */
      var pre=new Image();pre.decoding='async';
      if(im.getAttribute('srcset')){if(im.getAttribute('sizes'))pre.sizes=im.getAttribute('sizes');pre.srcset=im.getAttribute('srcset');}
      pre.src=u;
      im.setAttribute('loading','eager');return pre;}
    function csync(){var i=cnear();dots.forEach(function(d,j){d.classList.toggle('on',j===i);});cwarm(i);ccount();cedge(i);}
    /* The arrows used to stay visually alive at 1/N and N/N while cgo() silently
       clamped the index — PostHog showed 12-tap bursts on an 8-image gallery.
       Mark the exhausted edge so CSS can fade the arrow and taps can answer. */
    function cedge(i){var g=track.parentNode;if(!g)return;var last=S().length-1;
      var e=i<=0?'start':(i>=last?'end':'');
      if(e)g.setAttribute('data-edge',e);else g.removeAttribute('data-edge');
      if(cp)cp.setAttribute('aria-disabled',i<=0?'true':'false');
      if(cn)cn.setAttribute('aria-disabled',i>=last?'true':'false');}
    /* Tide stop: pressing past the end pulls the photos 10px and releases —
       the physical language of a shelf's end, matching what swipe already does.
       Suppressed under reduced motion; capped so a tap burst cannot strobe. */
    var nudgeAt=0,liveEdge=null;
    function cnudge(dir){var now=Date.now();if(now-nudgeAt<260)return;nudgeAt=now;
      if(!(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)){
        var cls=dir>0?'gcar-nudge-r':'gcar-nudge-l';
        track.classList.add(cls);
        setTimeout(function(){track.classList.remove(cls);},130);}
      if(!liveEdge){liveEdge=document.createElement('span');
        liveEdge.setAttribute('aria-live','polite');
        liveEdge.style.cssText='position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap';
        track.parentNode.appendChild(liveEdge);}
      var L=(document.documentElement.lang||'en').slice(0,2);
      var M={pl:['Pocz\u0105tek galerii.','Koniec galerii.'],cs:['Za\u010d\u00e1tek galerie.','Konec galerie.'],de:['Anfang der Galerie.','Ende der Galerie.'],nl:['Begin van de galerij.','Einde van de galerij.'],en:['Start of gallery.','End of gallery.']};
      var m=M[L]||M.en;liveEdge.textContent=dir>0?m[1]:m[0];}
    /* Where the shopper has ASKED to be, which is not where the strip has got
       to yet. cnear() reads scrollLeft, and cgo() animates with behavior
       'smooth', so a second tap arriving mid-animation rounded back to the
       slide the first tap started from and re-aimed at the same destination:
       three fast taps advanced two slides (measured live on jade-oil, 60ms
       gaps, 1/8 -> 3/8). The desktop path never had this because gshow() keeps
       an index; this is that index, for the carousel. PR #1827 made the same
       correction to the r45 and r13 engines on 2026-09-08 and did not reach
       this file. It is cleared whenever the shopper scrolls by hand, because
       then the strip's own position is the truth again. */
    var want = null;
    function cintent(){return want == null ? cnear() : want;}
    function cgo(i){
      var last=S().length-1;
      want=Math.max(0,Math.min(last,i));
      hydrateExtendedGallery();cwarm(want);
      track.scrollTo({left:cpos(want),behavior:'smooth'});
    }
    var userScroll=false;
    track.addEventListener('pointerdown',function(){userScroll=true;},{passive:true});
    track.addEventListener('touchstart',function(){userScroll=true;},{passive:true});
    track.addEventListener('scroll',function(){
      /* A scroll the shopper drove replaces the intent; one our own scrollTo
         drove is the intent arriving, so it must not overwrite it. */
      if(userScroll){want=null;userScroll=false;}
      else if(want!=null&&cnear()===want){want=null;}
      csync();
    },{passive:true});
    var cp=document.querySelector('.gcprev'),cn=document.querySelector('.gcnext');
    /* Hydrate the deferred slides BEFORE judging the edge: with 4 of 8 slides
       in the DOM, slide 4 would otherwise read as the end and refuse to advance. */
    if(cp)cp.addEventListener('click',function(){hydrateExtendedGallery();csync();var i=cintent();if(i<=0){cnudge(-1);return;}cgo(i-1);});
    if(cn)cn.addEventListener('click',function(){hydrateExtendedGallery();csync();var i=cintent();if(i>=S().length-1){cnudge(1);return;}cgo(i+1);});
    /* The dots look tappable, so let them be tapped. */
    [].slice.call(dots).forEach(function(d,j){
      d.setAttribute('role','button');d.setAttribute('tabindex','0');
      d.setAttribute('aria-label',String(j+1));
      d.addEventListener('click',function(){cgo(j);});
      d.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();cgo(j);}});});
    /* The photograph runs edge to edge, so nothing peeks to hint that more
       exist. A plain count says it outright, in any language: you are on 1 of 7. */
    var counter=null;
    if(track.parentNode&&S().length>1){
      counter=document.createElement('span');
      counter.className='gcar-count';
      counter.setAttribute('aria-hidden','true');
      track.parentNode.appendChild(counter);
    }
    /* The total is the server's, never the hydrated count. Slides deferred into
       a <template> are invisible to `track.querySelectorAll('img')`, so on a
       gallery that defers, `S().length` is the eager count until the first
       swipe and the counter contradicted the dot row beside it. Falls back to
       the live count if the attribute is ever absent. */
    function ctotal(){var n=parseInt(track.getAttribute('data-total'),10);return (n>0)?n:S().length;}
    function ccount(){if(counter)counter.textContent=(cnear()+1)+' / '+ctotal();}
    /* The frame is 4:5 and fills by cover, which is wrong for the few slides shot
       at another ratio: cover silently eats the words printed on them. */
    function cfit(im){
      if(!im||!im.naturalWidth||im.__fit)return;
      im.__fit=1;
      var r=im.naturalWidth/im.naturalHeight;
      if(Math.abs(r-0.8)>0.02){im.style.objectFit='contain';}
    }
    function cfitAll(){S().forEach(function(im){
      if(im.complete)cfit(im); else im.addEventListener('load',function(){cfit(im);},{once:true});});}
    cfitAll();
    track.addEventListener('scroll',cfitAll,{passive:true});
    (function(){var i=cnear();dots.forEach(function(d,j){d.classList.toggle('on',j===i);});ccount();cedge(i);})();

    /* Have the whole set ready before anyone asks for it, one slide at a time,
       after window load (2026-10-31). This used to start three detached
       new Image()s as the file booted (cwarm(0)), inside the hero's window,
       and every other slide in the next idle moment; a detached Image is a
       document image fetch, so Chromium and Firefox held `load` until all of
       them landed. A <link rel=preload> (the desktop path's early warm, above)
       does not help here: a lazy slide that names the same URL binds to the
       preload while it is in flight, and then Chromium and WebKit hold `load`
       for it too (tests/browser/carousel-warm-keeps-load-proof.mjs, tried).
       So: after `load`, pull the deferred slides in, then each slide is asked
       for once the last has landed and the page has had an idle moment.
       Not where the strip is not drawn: assets/pdp-gallery-chrome.css keeps it
       display:none at every width now (#gmain and its thumbnails are the
       gallery), and every slide was fetched there for nothing, ~260 KB (seven slides at 780w) on
       inner-sanctum-attar on a phone. Not on Data Saver or a 2g line either.
       A swipe or an arrow still warms its own neighbours at once (csync). */
    var cwConn=navigator.connection||{};
    if(!cwConn.saveData&&!/(^|-)2g$/.test(cwConn.effectiveType||'')&&track.getClientRects().length){
      var cidle=window.requestIdleCallback||function(f){setTimeout(f,600);};
      var c0=S()[0];if(c0)c0.__warm=1;
      var cAt=1,cWarmAll=function(){
        if(cAt===1){try{hydrateExtendedGallery();}catch(e){}}
        var s=S(),pre=null;
        while(!pre&&cAt<s.length)pre=cwarmOne(s[cAt++]);
        if(!pre)return;
        var next=function(){pre.onload=pre.onerror=null;cidle(cWarmAll,{timeout:2500});};
        if(pre.complete)next();else{pre.onload=next;pre.onerror=next;}
      };
      if(document.readyState==='complete')setTimeout(cWarmAll,0);
      else addEventListener('load',function(){setTimeout(cWarmAll,0);},{once:true});
    }
  }
  /* Honour a tap that arrived before this file did. snippets/gallery-preboot-tap
     holds the last arrow or thumbnail press from parse time; the arrows are
     drawn and look alive for seconds while this deferred script waits for the
     document to finish parsing. Outside the swipe-strip block (2026-10-30): the
     guard now also paints a held press, and a page without the strip must still
     take it back and go live. */
  if (typeof window.__ssGalleryDrain === 'function') window.__ssGalleryDrain();
  var hero=document.querySelector('.hero');
  if(hero){
    new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('shown');this.unobserve(e.target);}},this)},{threshold:.02}).observe(hero);
    // reveal immediately if already in view at load
    if(hero.getBoundingClientRect().top<window.innerHeight)hero.classList.add('shown');
  }
})();

/* ---- scroll-reveal for every story block (null-guarded observer targets) ---- */
(function(){
  function reveal(sel,threshold,once){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('shown');if(once!==false)io.unobserve(e.target);}})},{threshold:threshold});
    [].slice.call(document.querySelectorAll(sel)).forEach(function(s){if(s)io.observe(s);});
  }
  /* JUDGMENT, recorded 2026-08-30 so nobody has to re-derive it (#701).
     These numbers are intersectionRatio: a fraction of the BLOCK's own height,
     not of the viewport. Two consequences, one live and one waiting.
       Live: a tall block trips late. Measured on the PL phone page, .maker is
       1093px, so its .12 needs 131px on screen while its first .r is visible
       from the first pixel. That is the gap the sweep kept finding.
       Waiting: the ratio a block can reach at all is viewportHeight/blockHeight,
       so once a block passes viewport/threshold the trigger becomes UNREACHABLE
       and the block never reveals. At .03 the reviews wall would have to pass
       28,133px on an 844px phone; the jade mobile PDP already measures 26,647px
       end to end. Nobody would have to edit a line for that page to break -- it
       arrives with content growth, silently.
     The correct permanent shape is viewport-relative: threshold 0 with a
     rootMargin like '0px 0px -12% 0px', which is bounded by the viewport and so
     cannot go unreachable, and fires after a constant amount of travel whatever
     the block's height. It is NOT done here on purpose: it moves the entrance
     timing of every block on three live pages, which is a design decision and
     wants a design pass, not a bug fix. The dwell floor in
     snippets/pdp-motion-gate.liquid removes the customer harm either way -- it
     is the safety net under both shapes, not a substitute for choosing one. */
  reveal('.why',.05);
  reveal('.felt',.08);
  reveal('.scent',.08,false);
  reveal('.maker',.12);
  reveal('.rarity',.1,false);
  reveal('.ritual',.1);
  reveal('.faq',.05);
  /* Tells the motion gate in snippets/pdp-motion-gate.liquid that an animator
     arrived, so its 2s watchdog stands down and the reveal keeps its designed
     behaviour. Set here, after the observers are wired — not at the top of the
     file — so a throw on the way down still opens the gate. */
  window.__ssPdpBooted = true;
  (function(){var kq=document.querySelector('.kq');if(!kq)return;
    new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('shown');this.unobserve(e.target);}},this)},{threshold:.06}).observe(kq);
    if(kq.getBoundingClientRect().top<window.innerHeight)kq.classList.add('shown');})();
  // scent: placeholder tint if an illustration hasn't loaded, and note-hover emphasis
  [].slice.call(document.querySelectorAll('.nimg img')).forEach(function(img,i){
    img.addEventListener('error',function(){img.style.display='none';img.parentNode.classList.add('ph'+(i+1))});
  });
  var tl=document.querySelector('.timeline');
  if(tl){[].slice.call(document.querySelectorAll('.notes .ncard')).forEach(function(c,i){
    c.addEventListener('mouseenter',function(){tl.classList.add('emph','e'+(i+1))});
    c.addEventListener('mouseleave',function(){tl.classList.remove('emph','e1','e2','e3')});
  });}
})();

/* ---- below-fold autoplay video: merged best-of defer ----
   perf: video src AND poster are both withheld (data-src / data-poster) so neither
   contends with the LCP image; each is armed as its section nears the viewport.
   Data Saver / 2G visitors get the poster but never the autoplay payload. Aspect-ratio
   reserves the slot, so arming never shifts layout.
   Reduced motion no longer withholds these (2026-09-14, Sho): they are the product's
   own hand-drawn scenes, and a reader who had the setting on saw a page of frozen
   posters with no way to start anything. Playback itself, including recovery when
   a browser refuses the first play(), belongs to ss-video-visibility.js. ---- */
(function(){
  var vids=[].slice.call(document.querySelectorAll('.pdp video source[data-src]')).map(function(s){return s.parentNode;});
  if(!vids.length)return;
  var connection=navigator.connection||navigator.mozConnection||navigator.webkitConnection;
  var constrained=!!(connection&&(connection.saveData||/(^|-)2g$/.test(connection.effectiveType||'')));
  /* THE POSTER'S RUNG (2026-11-01). A video poster cannot carry a srcset, so a
     data-poster-srcset (real theme-asset rungs: an asset_url ignores &width=) is
     resolved here for the box the poster is DRAWN in: object-fit: cover fills a
     square note with a 3:2 still, so the drawn width is height x aspect
     (data-poster-aspect). About 2x the drawn width, at most 2.2x on a 3x phone,
     the house rule (tests/browser/right-size-pictures-proof.mjs). Inner Sanctum's
     three notes took the 900px masters (302 KB) for 104px boxes; every visitor
     downloads the poster, and in iPhone Low Power Mode it is all they ever see. */
  function posterFor(v){var set=v.getAttribute('data-poster-srcset'),one=v.getAttribute('data-poster');if(!set)return one;
    var a=parseFloat(v.getAttribute('data-poster-aspect'))||0,w=v.clientWidth||0,h=v.clientHeight||0;
    var need=Math.max(w,a&&h?h*a:0)*Math.min(window.devicePixelRatio||1,2.2);if(!need)return one;
    var c=set.split(',').map(function(x){x=x.trim().split(/\s+/);return [x[0],parseInt(x[1],10)||0];}).filter(function(x){return x[0]&&x[1];}).sort(function(p,q){return p[1]-q[1];});
    for(var i=0;i<c.length;i++)if(c[i][1]>=need)return c[i][0];return c.length?c[c.length-1][0]:one;}
  function revealPoster(v){var poster=posterFor(v);if(poster){v.setAttribute('poster',poster);v.removeAttribute('data-poster');v.removeAttribute('data-poster-srcset');}}
  function arm(v){revealPoster(v);if(constrained)return;var s=v.querySelector('source[data-src]');if(s){s.src=s.getAttribute('data-src');s.removeAttribute('data-src');}try{v.load();}catch(e){}var p=v.play&&v.play();if(p&&p.catch)p.catch(function(){});}
  if(!('IntersectionObserver' in window)){vids.forEach(arm);return;}
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){arm(e.target);io.unobserve(e.target);}});},{rootMargin:'300px 0px'});
  vids.forEach(function(v){io.observe(v);});
})();

/* ---- hero quick answers: one chip open at a time, aria-expanded mirrors state.
   Content is server-rendered and visually collapsed, never display:none, so
   search engines and find-in-page still see it. Shared across every PDP. ---- */
(function(){
  var row=document.querySelector('[data-qa-row]');if(!row)return;
  var chips=[].slice.call(row.querySelectorAll('.qa-chip'));
  chips.forEach(function(c){c.addEventListener('click',function(){
    var w=document.getElementById(c.getAttribute('aria-controls'));if(!w)return;
    var wasOpen=c.getAttribute('aria-expanded')==='true';
    chips.forEach(function(o){o.setAttribute('aria-expanded','false');});
    [].slice.call(row.querySelectorAll('.qa-panelwrap.open')).forEach(function(p){p.classList.remove('open');});
    if(!wasOpen){c.setAttribute('aria-expanded','true');w.classList.add('open');}
  });});
})();

})();
